import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { Provider } from "react-redux";
import { store } from "./redux/store.ts";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { enablePwaAutoUpdater } from "./pwa-updater";
import { loadStripe } from '@stripe/stripe-js'; // Add this
import { Elements } from '@stripe/react-stripe-js'; // Add this

// Enable PWA auto-updater
enablePwaAutoUpdater();

// Initialize Stripe - Replace with your publishable key
const stripePromise = loadStripe(import.meta.env.VITE_PAYMENT_GATEWAY_PUBLIC_KEY );

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    {(() => {
      const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID as
        | string
        | undefined;
      if (!clientId) {
        console.error(
          "VITE_GOOGLE_CLIENT_ID is not set. Google login will be disabled."
        );
        return (
          <Provider store={store}>
            <Elements stripe={stripePromise}>
              <App />
            </Elements>
          </Provider>
        );
      }
      return (
        <GoogleOAuthProvider clientId={clientId}>
          <Provider store={store}>
            <Elements stripe={stripePromise}>
              <App />
            </Elements>
          </Provider>
        </GoogleOAuthProvider>
      );
    })()}
  </React.StrictMode>
);